// extracted by mini-css-extract-plugin
export default {"day":"timeline-day-module--day--UvDqK","active":"timeline-day-module--active--TWr3+"};